// Data sevice
import axios from "axios";
import authHeader from "./auth-header";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
const API_URL = process.env.VUE_APP_API_URL;

class ListingCostService {
  index() {
    return axios.get(API_URL + "listing-cost", { headers: authHeader() });
  }
  show(id) {
    return axios.get(API_URL + "listing-cost/" + id, { headers: authHeader() });
  }
  store(resource) {
    return axios.post(API_URL + "listing-cost", resource, {
      headers: authHeader(),
    });
  }
  update(resource) {
    return axios.put(API_URL + "listing-cost/" + resource.id, resource, {
      headers: authHeader(),
    });
  }
  delete(resource) {
    return axios.delete(API_URL + "listing-cost/" + resource.id, {
      headers: authHeader(),
    });
  }
}

export default new ListingCostService();
